export default __webpack_public_path__ + "static/media/pictogramHealth48.cb01ab97.svg";